module.exports = __webpack_public_path__ + "img-dashboard/register/web-cv-kotagede.d0e1486c.png";